import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";
import {sessionData} from './stores.js'

const firebaseConfig = {
  apiKey: "AIzaSyDhN9Q_GLXFZbq8w6bx-ATLai7bTSUoPR8",
  authDomain: "gambitai.firebaseapp.com",
  projectId: "gambitai",
  storageBucket: "gambitai.appspot.com",
  messagingSenderId: "850553560545",
  appId: "1:850553560545:web:d032344e2d01371eb206a0",
  measurementId: "G-FGWFP1QD47"
  }

// a counter which increments every second




// Initialize our firebase for our application
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
setPersistence(auth, browserSessionPersistence)

auth.languageCode = 'en'

export  {auth}
